export function checkValidPassword(password) {
    const match = String(password).match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/);
    if (match) return true;
    return false
}
